export { default } from "./SearchFeedBack.js";
